import React from 'react';
import BookingsListFunctional from './components/bookings-list-functional';

const BookingsList = () => {
	return <BookingsListFunctional />;
};

export default BookingsList;
